import { createSlice, createAction } from '@reduxjs/toolkit';

import { COMPONENTS as ModalTypes } from '~/constants/modal';

const initialState = {
    isOpen: false,
    component: null,
    withCloseButton: true,
    size: 'responsive', // possible values 'responsive'| 'static'
    props: {},
};
Object.freeze(initialState);

const modalSlice = createSlice({
    name: 'modal',
    initialState: initialState,
    reducers: {
        openModal(state, { payload: { component, withCloseButton, props, size } }) {
            state.isOpen = true;
            state.props = props;
            state.component = component;
            state.size = size ?? initialState.size;
            state.withCloseButton = withCloseButton ?? initialState.withCloseButton;
        },
        closeModal(state) {
            Object.assign(state, initialState);
        },
    },
    extraReducers: {},
});

export const { closeModal, openModal } = modalSlice.actions;
export const openAnnotationEditorModal = (props) =>
    createAction(openModal.type)({
        component: ModalTypes.ANNOTATION_EDITOR,
        withCloseButton: false,
        props,
    });
export const openHotKeysModal = (props) =>
    createAction(openModal.type)({
        component: ModalTypes.HOT_KEYS_CHEAT_SHEET,
        props,
    });
export const openSettingsModal = (props) =>
    createAction(openModal.type)({
        component: ModalTypes.SETTINGS_MENU,
        size: 'static',
        props,
    });

export default modalSlice.reducer;
